// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2SSKL","tab":"ProcedureTabs_tab__3Syw8"};